import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import ProductsPageLayout from "./products-page";

export default function ExtrasRoutes() {
  return (
    <Routes>
      <Route index element={<Navigate to="products-page" replace />} />
      <Route path="products-page" element={<ProductsPageLayout />} />
      <Route path="*" element={<Navigate to="/error" replace />} />
    </Routes>
  );
}
